import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './AppointmentHistoryItem.module.css';
import CustomButton from '../../../../../../components/buttons/CustomButton';
import { DataProviderInstance } from "../../../../../../api/DataProvider";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import AppointmensState from '../../../../../../consts/AppointmentsState';
import { procedureLabels } from '../../../../../appointments/v2/utils/appointmentUtils';

const AppointmentHistoryItem = ({ data }) => {
    const { CompanyConfig } = DataProviderInstance();
    const navigate = useNavigate();

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };

    const formatTime = (dateString) => {
        const date = new Date(dateString);
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${hours}:${minutes}`;
    };

    const handleViewDetails = () => {
        navigate(`/appointment/${data.id}`);
    }

    const procedure = procedureLabels(data, CompanyConfig.Procedures) || 'Não especificado';
    const procedureLabel = (data.procedures?.length || 0) > 1 ? 'Procedimentos:' : 'Procedimento:';
    const resource = CompanyConfig.Resources.find(item => item.Id == data.resource)?.Label || 'Não especificado';
    const status = AppointmensState.GetLabel(data.status);

    return (
        <div className={styles.container}>
            <div className={styles.infos}>
                <p data-label="Data:" className={styles.dateTime}>{formatDate(data.date)}</p>
                <p data-label="Horário:" className={styles.dateTime}>{formatTime(data.date)}</p>
                <p data-label="Status:" className={styles.state}>{status}</p>
                <p data-label={procedureLabel} className={styles.procedure}>{procedure}</p>
                <p data-label="Profissional:" className={styles.resource}>{resource}</p>
            </div>
            <CustomButton
                style="secondary"
                variant="outlined"
                icon={<InfoOutlinedIcon fontSize="small" />}
                onClick={handleViewDetails}
                rounded={true}
            />
        </div>
    );
};

export default AppointmentHistoryItem;